import { render, staticRenderFns } from "./help-classify.vue?vue&type=template&id=5b70f5d0&scoped=true"
import script from "./help-classify.vue?vue&type=script&lang=js"
export * from "./help-classify.vue?vue&type=script&lang=js"
import style0 from "./help-classify.vue?vue&type=style&index=0&id=5b70f5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70f5d0",
  null
  
)

export default component.exports